export const NATIVE_MESSAGE_LIMIT = 100_000;

export function messageTextLength(body: string): number {
  let length = 0;
  for (const _character of body) length++;
  return length;
}

export function messageLengthError(body: string, limit = NATIVE_MESSAGE_LIMIT): string | null {
  const length = messageTextLength(body);
  if (length <= limit) return null;
  const format = (value: number): string => String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return `Текст слишком длинный: ${format(length)} символов, максимум — ${format(limit)}. Сократите текст или отправьте его файлом.`;
}
